import React from "react";
import { Field } from "redux-form/immutable";
import { Grid, MenuItem } from "@material-ui/core";

import TextField from "app/components/form/TextField";
import DatePickerField from "app/components/form/DatePickerField";
import { WORK_SCHEDULE_OVERRIDE_REASONS } from "features/planner/planner.constants";
import { workScheduleOverrideReasonToString } from "features/planner/planner.mappers";
import { WORK_SCHEDULE_OVERRIDE_FORM } from "features/planner/employee/employee.constants";
import { required } from "utils/validation.util";

const WorkScheduleOverrideForm = ({ handleSubmit }) => (
  <form onSubmit={handleSubmit} id={WORK_SCHEDULE_OVERRIDE_FORM.ID}>
    <Grid container direction="column">
      <Grid container item xs>
        <Field
          autoFocus
          required
          fullWidth
          select
          validate={[required]}
          margin="normal"
          label="Reason"
          component={TextField}
          name={WORK_SCHEDULE_OVERRIDE_FORM.REASON}
        >
          {Object.values(WORK_SCHEDULE_OVERRIDE_REASONS).map(reason => (
            <MenuItem key={reason} value={reason}>
              {workScheduleOverrideReasonToString(reason)}
            </MenuItem>
          ))}
        </Field>
      </Grid>
      <Grid container item xs>
        <Field
          rows={3}
          multiline
          fullWidth
          margin="normal"
          label="Notes"
          component={TextField}
          name={WORK_SCHEDULE_OVERRIDE_FORM.NOTES}
        />
      </Grid>
      <Grid container spacing={2}>
        <Grid container item xs={6}>
          <Field
            validate={[required]}
            component={DatePickerField}
            name={WORK_SCHEDULE_OVERRIDE_FORM.START_DATE}
            DatePickerProps={{
              required: true,
              margin: "normal",
              label: "From",
            }}
          />
        </Grid>
        <Grid container item xs={6}>
          <Field
            validate={[required]}
            component={DatePickerField}
            name={WORK_SCHEDULE_OVERRIDE_FORM.END_DATE}
            DatePickerProps={{
              required: true,
              margin: "normal",
              label: "To",
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  </form>
);

export default WorkScheduleOverrideForm;
